<template>
    <div class="col-lg-12">
        <div class="box">
            <div class="cont">
                <div class="top">
                    <p v-if="parseInt(offers) < 3" class="left">
                        {{ $t('offer.three_can_create') }} 
                        <span class="actual">{{ 3 - parseInt(offers)}} ponuky</span> 
                        <span class="from">z 3</span>
                    </p>
                    <p v-if="parseInt(offers) >= 3" class="left">
                        {{ $t('offer.three_limit_reached') }} 
                        {{ $t('offer.three_currently_active') }}
                        <span class="actual red">3 ponuky</span> 
                        <span class="from">z 3</span>
                    </p>
                    <p class="right">
                        Upgradni na
                        <a href="/admin/balicky">
                            DOFFERO PREMIUM         
                            <svg width="13" height="11" viewBox="0 0 13 11" fill="none">
                                <path d="M1.1073 0.86798L3.64397 3.09998L5.90397 0.317313C5.96725 0.23952 6.04727 0.177006 6.13806 0.134427C6.22886 0.0918475 6.32809 0.0703002 6.42837 0.0713894C6.52864 0.0724787 6.62738 0.0961766 6.71723 0.140718C6.80708 0.18526 6.88572 0.249497 6.9473 0.328646L9.10397 3.09931L11.7226 0.835313C11.8255 0.746586 11.953 0.691386 12.088 0.677101C12.2231 0.662816 12.3593 0.690127 12.4784 0.755378C12.5975 0.82063 12.6939 0.92071 12.7546 1.04222C12.8153 1.16374 12.8374 1.30088 12.818 1.43531L11.818 8.33331H1.02263L0.00729935 1.46665C-0.0128692 1.33147 0.00899595 1.19336 0.069933 1.07103C0.13087 0.94869 0.227934 0.848039 0.34798 0.782706C0.468025 0.717372 0.60525 0.690513 0.741068 0.705765C0.876887 0.721018 1.00474 0.777646 1.1073 0.86798ZM1.07463 8.99998H11.7413V9.66665C11.7413 9.84346 11.6711 10.013 11.546 10.1381C11.421 10.2631 11.2514 10.3333 11.0746 10.3333H1.7413C1.56449 10.3333 1.39492 10.2631 1.2699 10.1381C1.14487 10.013 1.07463 9.84346 1.07463 9.66665V8.99998Z" fill="#FBBF24"/>
                            </svg>
                        </a>
                    </p>
                </div>
                <div class="bar">
                    <span :class="parseInt(offers) == 1 ? 'one active' : 'one'"></span>
                    <span :class="parseInt(offers) == 2 ? 'two active' : 'two'"></span>
                    <span :class="parseInt(offers) >= 3 ? 'three active' : 'three'"></span>
                </div>
                <div class="info">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                        <path d="M11 14.5H10V10.5H9M10 6.5H10.01M19 10.5C19 11.6819 18.7672 12.8522 18.3149 13.9442C17.8626 15.0361 17.1997 16.0282 16.364 16.864C15.5282 17.6997 14.5361 18.3626 13.4442 18.8149C12.3522 19.2672 11.1819 19.5 10 19.5C8.8181 19.5 7.64778 19.2672 6.55585 18.8149C5.46392 18.3626 4.47177 17.6997 3.63604 16.864C2.80031 16.0282 2.13738 15.0361 1.68508 13.9442C1.23279 12.8522 1 11.6819 1 10.5C1 8.11305 1.94821 5.82387 3.63604 4.13604C5.32387 2.44821 7.61305 1.5 10 1.5C12.3869 1.5 14.6761 2.44821 16.364 4.13604C18.0518 5.82387 19 8.11305 19 10.5Z" stroke="#212541" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p>
                        {{ $t('offer.three_free_info') }} 
                        <b>{{ $t('offer.three_free_count') }}</b> 
                        {{ $t('offer.three_deactivate_hint') }}
                        alebo <a href="/admin/balicky">upgradni na DOFFERO PREMIUM.</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['offers']
    }
</script>

<style lang="scss" scoped>
.box{
    margin-bottom: 20px;
    width: 100%;
    height: 111px;
    background: #FFFFFF;
    border-radius: 3px;
    font-family: Roboto;
    padding: 25px;
    @media only screen and (max-width: 1500px) {
        height: auto;
    }
    @media only screen and (max-width: 800px) {
        padding: 15px;
    }
    .top{
        display: flex;
        align-items: center;
        justify-content: space-between;
        @media only screen and (max-width: 800px) {
            display: grid;
        }
        p.left{
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
            span.actual{
                color: #45D7B6;
            }
            span.actual.red{
                color: #F93C34;
            }
            span.from{
                color: #BDBDBD;
            }
        }
        p.right{
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
            a{
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 16px;
                text-decoration-line: underline;
                color: #F59E0B;
                svg{
                    margin-left: 6px;
                }
            }
        }
    }
    .bar{
        position: relative;
        width: 100%;
        height: 3px;
        background-color: #D0D8DF;
        span{
            position: absolute;
            left: 0;
            top: 0;
            height: 3px;
            width: 0;
            transition: .5s ease all;
            &.one.active{
                background: #45D7B6;
                z-index: 1;
                width: 33.3333%;
            }
            &.two.active{
                background: #F59E0B;
                width: 66.66666%;
                z-index: 2;
            }
             &.three.active{
                background: #F93C34;
                width: 100%;
                z-index: 3;
            }
        }
    }
    .info{
        display: flex;
        align-items: center;    
        margin-top: 13px;
        svg{
            margin-right: 13px;    
            margin-bottom: 4px;
            @media only screen and (max-width: 800px) {
                width: 40px;
            }
        }
        p{
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 182.5%;
            color: #212541;
            margin: 0;
            b{
                font-weight: bold;
            }
            a{
                font-weight: bold;
                text-decoration: underline;
                &:hover{
                    color: #212541;
                }
            }
        }
    }
}

</style>